/**
 Project	ENT - Environnement numérique de travail

 @file 	    app.service.ts
 @author  	Martin Tazlari <martin.tazlari@ictvs.ch>
 @copyright © 2020, ICT-vs. All rights reserved.
**/

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LastUpdateResponse } from 'src/app/models/services/last-update-response.model';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  constructor(private http: HttpClient) {}

  /**
   * Force the API to load or upate the services cache
   * @returns An observable with an empty response
   */
  fetchServices(): Observable<void> {
    return this.http.get<void>(environment.apiUrl + '/services/populate', {});
  }

  /**
   * Get the cache last updated datetime as a string
   * @returns
   */
  getLastUpdateDate(): Observable<string> {
    return this.http
      .get<LastUpdateResponse>(environment.apiUrl + '/services/lastupdate', {})
      .pipe(
        map(response => {
          return response.lastupdate;
        })
      );
  }
}
